import { React, useState, useEffect, useContext, useRef } from "react";
import Button from "@mui/material/Button";
import { DataGrid } from '@mui/x-data-grid';
import GridNoRow from '../../../../common/GridNoRow';
import axios from "axios";
import Moment from 'moment';
import Swal from "sweetalert2";
import { AppContext } from '../../../../AppStore';
import { useNavigate, useLocation, useParams } from "react-router-dom";
import { Box, Typography, TextField, MenuItem, Select as MuiSelect, FormControl } from '@mui/material';
import noImg from "../../../../img/noimg.png";

const TAB_ENC_PressProcess = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const params = useParams();
    const appStore = useContext(AppContext);

    // 권한 및 메뉴 State
    const [MenuID, setMenuID] = useState(0);
    const [MenuName, setMenuName] = useState('');
    const [MenuUpdateExistYN, setMenuUpdateExistYN] = useState('N');
    const [MenuDeleteExistYN, setMenuDeleteExistYN] = useState('N');
    const [MenuUpdateYN, setMenuUpdateYN] = useState('N');
    const [MenuDeleteYN, setMenuDeleteYN] = useState('N');

    const [rows, setRows] = useState([]);
    const [columns, setColumns] = useState([]);
    const [columnVisibilityModel, setColumnVisibilityModel] = useState({
        id: false, status: false, job_number: true, item_name: true,
    });

    const [selectedRowId, setSelectedRowId] = useState('NEW');
    const [inputs, setInputs] = useState({
        selected_bom_id: '',
        sheet_count: '' // 사용 시트 수량 (장)
    });

    const [bomOptions, setBomOptions] = useState([]);
    const sheetCountRef = useRef(null);

    // ★ 이미지 확대 모달 State
    const [imgModal, setImgModal] = useState({ open: false, title: '', src: '' });

    // ★ 요청하신 높이: calc(100vh - 100px)
    const availHeight = 'calc(100vh - 100px)';

    // 권한 체크
    useEffect(() => {
        const accessList = JSON.parse(localStorage.getItem("nav"));
        const currentPath = String(window.location.pathname).split("/").slice(0, 3).join("/");
        const isMatch = (url) => String(url) === currentPath || "/" + String(url) === currentPath;

        if (Array.isArray(accessList) && accessList.filter(item => isMatch(item.menu_url)).length > 0) {
            const matched = accessList.find(item => isMatch(item.menu_url));
            setMenuID(matched.menu_id);
            setMenuName(matched.menu_name);
            setMenuUpdateExistYN(matched.menu_update_exist_yn);
            setMenuDeleteExistYN(matched.menu_delete_exist_yn);
            setMenuUpdateYN(matched.menu_update_yn);
            setMenuDeleteYN(matched.menu_delete_yn);
        } else {
            Swal.fire({ title: '<p style="color:red">접근 권한 오류</p>', text: '화면에 접근 권한이 없습니다.', confirmButtonText: '확인', confirmButtonColor: '#7066e0', timer:5000, timerProgressBar: true }).then(() => { navigate(-1); });
        }
    }, []);

    const handleSetting = () => {
        setColumns([
            { field: 'id', headerName: 'id', width: 0, headerAlign: 'center' },
            { field: 'status', headerName: '상태', width: 0, headerAlign: 'center' },
            { field: 'job_number', headerName: '번호', width: 165, headerAlign: 'center', align: 'center' },
            { field: 'item_name', headerName: '품목', flex: 1, minWidth: 120, headerAlign: 'center', align: 'left' },
        ]);
    };

    // 좌측 목록 : 프레스 공정 등록 실적 조회
    const handleView = () => {
        if (appStore.loading) return;
        appStore.setLoading(true);

        axios.get('/api/p/ENCPressProcess/SelectList', { withCredentials: true })
        .then((response) => {
            const array = (response.data ?? []).map((item) => ({
                id: item.produce_work_id,
                status: (typeof item.produce_work_status === 'undefined' ? '' : String(item.produce_work_status)),
                status_name: (typeof item.produce_work_status_name === 'undefined' || item.produce_work_status_name === null ? '' : String(item.produce_work_status_name)),
                job_number: (typeof item.produce_work_number === 'undefined' ? '' : String(item.produce_work_number)),
                item_name: (typeof item.produce_work_item_name === 'undefined' ? '' : String(item.produce_work_item_name)),
                item_spec: (typeof item.produce_work_item_spec === 'undefined' ? '' : String(item.produce_work_item_spec)),
                item_img_sever: item.item_img_sever || '',
                bom_id: (typeof item.produce_work_bom_id === 'undefined' ? '' : String(item.produce_work_bom_id)),
                bom_name: (typeof item.produce_work_bom_name === 'undefined' ? '' : String(item.produce_work_bom_name)),
                sheet_count: Number(item.input_item_count ?? item.sheet_count ?? 0), // 사용 시트 수량
                produce_count: Number(item.produce_work_count ?? 0),                 // 생산 수량
                complete_count: Number(item.produce_work_complete_count ?? 0),       // 양품 수량
                error_count: Number(item.produce_work_error_count ?? 0),             // 불량 수량
                use_yn: (typeof item.use_yn === 'undefined' || item.use_yn === null ? 'N' : String(item.use_yn)),
                bigo: (typeof item.produce_work_bigo === 'undefined' || item.produce_work_bigo === null ? '' : String(item.produce_work_bigo)),
                start_datetime: (!item.produce_work_start_datetime ? '' : Moment(item.produce_work_start_datetime).format('YYYY-MM-DD HH:mm')),
                end_datetime: (!item.produce_work_end_datetime ? '' : Moment(item.produce_work_end_datetime).format('YYYY-MM-DD HH:mm')),
                reg_user_name: (typeof item.update_user_name === 'undefined' ? '' : String(item.update_user_name)),
                reg_datetime: (typeof item.reg_datetime === 'undefined' || !item.reg_datetime ? '' : Moment(item.reg_datetime).format('YYYY-MM-DD HH:mm:ss')),
            }));
            setRows(array);
        })
        .catch((error) => { console.log(error); })
        .finally(() => { appStore.setLoading(false); });
    };

    // 프레스 대상 BOM 목록 조회
    const fetchBomOptions = () => {
        axios.get('/api/p/ENCPressProcess/SelectBomList', { withCredentials: true })
        .then((res) => {
            const options = (res.data ?? []).map((item) => ({
                bom_id: item.bom_id,
                bom_name: item.bom_name,
                item_id: item.item_id,
                item_name: item.item_name,
                item_spec: (appStore.ITEM_FULL_SPEC_MAKE
                    ? appStore.ITEM_FULL_SPEC_MAKE(item.item_spec, item.item_width, item.item_depth, item.item_height)
                    : (item.item_spec ?? '')),
                item_img_sever: item.item_img_sever || '',             // ★ 반제품 이미지 서버 파일명
                bom_item_count: Number(item.bom_item_count ?? item.item_count ?? 1), // 시트 1장당 생산 수량
                input_item_id: item.input_item_id,                     // 투입 시트 자재 ID
                input_item_name: item.input_item_name,
                input_item_spec: item.input_item_spec,
                input_stock: Number(item.input_stock ?? 0),            // 시트 재고
                product_stock: Number(item.product_stock ?? 0),        // 반제품 재고
            }));
            setBomOptions(options);
        })
        .catch((err) => { appStore.capture ? appStore.capture() : console.log(err); });
    };

    useEffect(() => {
        if(String(MenuID) !== String(0) && MenuID != null){
            handleSetting();
            fetchBomOptions();
            handleView();
        }
    }, [MenuID]);

    // 삭제
    const DeleteClick = (object) => {
        if (String(object.row.use_yn) === 'Y') {
            Swal.fire({ title: '<p style="color:red">삭제 불가</p>', html: '생산품이 이미 사용/출하되어 삭제할 수 없습니다.', confirmButtonText: '확인' });
            return;
        }
        Swal.fire({
            title: '번호 '+object.row.job_number+' 삭제',
            html : '<b>'+object.row.item_name+'</b><br/>해당 프레스 실적을 <span style="color:red;font-weight:bold;">삭제</span> 하시겠습니까?',
            showCancelButton: true, confirmButtonColor: '#d33', confirmButtonText: '삭제', cancelButtonText: '닫기'
        }).then((result) => {
            if (result.isConfirmed) {
                if (appStore.loading) return;
                appStore.setLoading(true);
                axios.post('/api/p/ENCPressProcess/Delete', new URLSearchParams({
                    delete_produce_work_id: object.row.id,
                    folder: 'ProduceWork'
                }), { withCredentials: true })
                .then((response) => {
                    if (String(response.data) === "N") {
                        if (String(selectedRowId) === String(object.row.id)) { setSelectedRowId('NEW'); }
                        Swal.fire({ title: '삭제 완료', text: '정상적으로 삭제되었습니다.', confirmButtonText: '확인', timer: 3000, timerProgressBar: true });
                        handleView();
                    } else {
                        Swal.fire({ title: '<p style="color:red">삭제 불가</p>', html: response.data, confirmButtonText: '확인' });
                    }
                })
                .catch((error) => { appStore.capture ? appStore.capture() : console.log(error); })
                .finally(() => { appStore.setLoading(false); });
            }
        });
    };

    const handleNew = () => {
        fetchBomOptions();
        handleView();
        setSelectedRowId('NEW');
        setInputs({ selected_bom_id: '', sheet_count: '' });
    };

    const RowClick = (params) => { setSelectedRowId(params.row.id); };

    const selectedBom = bomOptions.find(bom => String(bom.bom_id) === String(inputs.selected_bom_id)) || null;

    const onChangeBom = (e) => {
        setInputs({ selected_bom_id: e.target.value, sheet_count: '' });
        setTimeout(() => { if (sheetCountRef.current) sheetCountRef.current.focus(); }, 0);
    };

    const onChangeSheet = (e) => {
        setInputs({ ...inputs, sheet_count: e.target.value });
    };

    const sheetStep = (delta) => {
        const cur = inputs.sheet_count === '' ? 0 : Number(inputs.sheet_count);
        const next = Math.max(0, cur + delta);
        setInputs({ ...inputs, sheet_count: String(next) });
    };

    const sheetCnt = inputs.sheet_count === '' ? 0 : Number(inputs.sheet_count);
    const produceQty = (selectedBom && sheetCnt > 0) ? sheetCnt * selectedBom.bom_item_count : 0;

    const selectedRecord = rows.find(r => String(r.id) === String(selectedRowId)) || null;

    const handleSave = () => {
        if (!inputs.selected_bom_id) { Swal.fire({ title: '입력 오류', text: '사용 시트(BOM)를 선택해주세요.', confirmButtonText: '확인' }); return; }
        if (!inputs.sheet_count || sheetCnt <= 0) { Swal.fire({ title: '입력 오류', text: '사용 시트 수량을 정확히 입력해주세요.', confirmButtonText: '확인' }); return; }
        if (selectedBom && sheetCnt > (Number(selectedBom.input_stock) || 0)) {
            Swal.fire({ title: '재고 부족', text: '사용 시트 수량이 원단(시트) 재고보다 많습니다.', confirmButtonText: '확인' }); return;
        }
        const LOT_MAX = 999999;
        if (produceQty > LOT_MAX) {
            Swal.fire({
                title: '생산수량 초과',
                html: `한 번에 생성 가능한 Lot 수량은 <b>${LOT_MAX.toLocaleString()}개</b>까지입니다.<br/>시트 수량을 나눠 등록해주세요.`,
                confirmButtonText: '확인'
            });
            return;
        }

        Swal.fire({
            title: '프레스 실적 등록',
            html: `
                생산 품목: <b>${selectedBom.item_name}</b><br/>
                사용 시트: <b>${sheetCnt.toLocaleString()} 장</b> (1장당 ${selectedBom.bom_item_count.toLocaleString()}개)<br/>
                <hr style="margin:10px 0;"/>
                생산 수량: <b style="color:#28a745">${produceQty.toLocaleString()}</b> 개<br/><br/>
                위 실적으로 등록하시겠습니까?
            `,
            showCancelButton: true,
            confirmButtonText: '실적 등록',
            cancelButtonText: '닫기',
            confirmButtonColor: '#2f7ed8'
        }).then((resp) => {
            if (resp.isConfirmed) {
                if (appStore.loading) return;
                appStore.setLoading(true);

                // ★ ENCPressProcessController.Reg 파라미터명 완벽 매칭
                const payload = {
                    bom_id: selectedBom.bom_id,
                    item_id: selectedBom.item_id,
                    item_name: selectedBom.item_name,
                    item_spec: selectedBom.item_spec,
                    sheet_count: sheetCnt,
                    input_item_count: sheetCnt,
                    produce_count: produceQty,
                    complete_count: produceQty,
                    error_count: 0,
                    sheet_item_id: selectedBom.input_item_id,
                    sheet_item_name: selectedBom.input_item_name,
                    sheet_item_spec: selectedBom.input_item_spec,
                    input_item_id: selectedBom.input_item_id,
                    input_item_name: selectedBom.input_item_name,
                    input_item_spec: selectedBom.input_item_spec,
                    bigo: ''
                };

                axios.post('/api/p/ENCPressProcess/Reg', payload, { withCredentials: true })
                .then((response) => {
                    if (Number(response.data) > 0) {
                        Swal.fire({ title: '등록 완료', text: '프레스 실적이 정상적으로 등록되었습니다.', confirmButtonText: '확인', timer: 2500, timerProgressBar: true });
                        setInputs({ selected_bom_id: '', sheet_count: '' });
                        setSelectedRowId('NEW');
                        handleView();
                    } else {
                        Swal.fire({ title: '<p style="color:red">실적 등록 오류</p>', html: '등록에 실패했습니다. (재고/입력값 확인)', confirmButtonText: '확인' });
                    }
                })
                .catch((error) => { appStore.capture ? appStore.capture() : console.log(error); })
                .finally(() => { appStore.setLoading(false); });
            }
        });
    };

    const getImgSrc = (severName) => (severName && String(severName).trim() !== '' ? `/files/${severName}` : noImg);

    // ★ 이미지 클릭 시 확대 모달 오픈 (제목: BOM명)
    const openImageModal = (e, bomTitle, severName) => {
        if (e) {
            e.preventDefault();
            e.stopPropagation();
        }
        if (!bomTitle) {
            Swal.fire({ title: '알림', text: '먼저 BOM을 선택해주세요.', confirmButtonText: '확인', confirmButtonColor: '#3D63AE' });
            return;
        }
        setImgModal({
            open: true,
            title: bomTitle,
            src: getImgSrc(severName)
        });
    };

    return (
        <div style={{ display: String(MenuID) === String(0) ? 'none' : 'flex', flexDirection: 'column', width: '100%', height: availHeight, backgroundColor: '#fff', overflow: 'hidden', boxSizing: 'border-box' }}>

            {/* 상단 헤더 */}
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '6px 20px', borderBottom: '1px solid #ccc', backgroundColor: '#fff', height: '54px', flexShrink: 0, boxSizing: 'border-box' }}>
                <div style={{ fontSize: '25px', fontWeight: 'bold', color: '#333', display: 'flex', alignItems: 'center' }}>
                    <span style={{ width: '5px', height: '26px', backgroundColor: '#3D63AE', marginRight: '10px' }}></span>
                    {MenuName}
                </div>
                <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
                    {MenuUpdateYN === 'Y' && (
                        <Button onClick={handleNew} sx={{ fontSize: 18, fontWeight: 'bold', minWidth: '92px', height: '44px', color: "white", backgroundColor: "#FF3636", borderColor: "#FF3636", ":hover": {backgroundColor: "#FF3636"} }} variant="outlined">등록</Button>
                    )}
                    <Button onClick={handleView} className="btn-p" sx={{ fontSize: 18, fontWeight: 'bold', minWidth: '92px', height: '44px', color: "white", backgroundColor: "#3D63AE", borderColor: "#3D63AE", ":hover": {backgroundColor: "#3D63AE"} }} variant="outlined">조회</Button>
                </div>
            </div>

            {/* 하단 2단 분할 (절대 스크롤 방지) */}
            <div style={{ display: 'flex', flex: 1, width: '100%', minHeight: 0, overflow: 'hidden' }}>

                {/* 👈 좌측 리스트 */}
                <div style={{ width: '390px', height: '100%', borderRight: '1px solid #ccc', display: 'flex', flexDirection: 'column', backgroundColor: '#fff', flexShrink: 0 }}>
                    <div style={{ flex: 1, width: '100%', minHeight: 0 }}>
                        <DataGrid
                            rows={rows}
                            columns={columns}
                            slots={{ noRowsOverlay: GridNoRow }}
                            columnVisibilityModel={columnVisibilityModel}
                            AlternatingRowBackground="LavenderBlush"
                            rowsPerPageOptions={[20, 50, 100]}
                            onRowClick={(params) => RowClick(params)}
                            disableColumnMenu
                            getRowClassName={(params) => (String(params.id) === String(selectedRowId) ? 'row-selected' : '')}
                            sx={{
                                height: '100%',
                                border: 'none',
                                '& .MuiDataGrid-virtualScroller': { overflowX: 'hidden' },
                                '& .MuiDataGrid-columnHeaderTitle': { fontSize: '17px', fontWeight: 'bold' },
                                '& .MuiDataGrid-cell': { fontSize: '18px' },
                                '& .row-selected': { backgroundColor: '#e3f2fd !important' },
                                '& .MuiDataGrid-row': { cursor: 'pointer' },
                            }}
                            rowHeight={54}
                        />
                    </div>
                </div>

                {/* 👉 우측 폼 */}
                <div style={{ flex: 1, height: '100%', backgroundColor: '#f5f5f5', display: 'flex', flexDirection: 'column', overflow: 'hidden', padding: '16px 28px', boxSizing: 'border-box', alignItems: 'center' }}>
                    {String(selectedRowId) === 'NEW' ? (
                        /* ===== 신규 프레스 실적 등록 폼 ===== */
                        <Box sx={{ width: '100%', maxWidth: '1000px', height: '100%', display: 'flex', flexDirection: 'column', justifyContent: 'space-between', minHeight: 0 }}>
                            
                            {/* 1. 사용 시트 (Select Box + ★ 우측 옆 96x96 큼직한 품목 이미지 박스) */}
                            <Box>
                                <Typography sx={{ fontSize: '19px', fontWeight: 'bold', mb: 0.8, color: '#555' }}>사용 시트 (BOM)</Typography>
                                <Box sx={{ display: 'flex', gap: '14px', alignItems: 'stretch', width: '100%' }}>
                                    <Box sx={{ flex: 1, minWidth: 0, display: 'flex', flexDirection: 'column', justifyContent: 'space-between' }}>
                                        <FormControl fullWidth>
                                            <MuiSelect
                                                value={inputs.selected_bom_id}
                                                onChange={onChangeBom}
                                                displayEmpty
                                                renderValue={(selected) => {
                                                    if (!selected) return <span style={{ color: '#888' }}>BOM 선택</span>;
                                                    const sel = bomOptions.find(b => String(b.bom_id) === String(selected));
                                                    if (!sel) return '';
                                                    return (
                                                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
                                                            <img
                                                                src={getImgSrc(sel.item_img_sever)}
                                                                onError={(e) => { e.currentTarget.src = noImg; }}
                                                                onMouseDown={(e) => { e.stopPropagation(); }}
                                                                onTouchStart={(e) => { e.stopPropagation(); }}
                                                                onClick={(e) => openImageModal(e, sel.bom_name, sel.item_img_sever)}
                                                                alt=""
                                                                style={{ width: '44px', height: '44px', objectFit: 'cover', borderRadius: '6px', border: '1px solid #ddd', backgroundColor: '#fff', flexShrink: 0, cursor: 'zoom-in' }}
                                                            />
                                                            <span style={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{sel.bom_name}</span>
                                                        </Box>
                                                    );
                                                }}
                                                sx={{ fontSize: '25px', height: '64px', backgroundColor: '#fff', fontWeight: 'bold', borderRadius: 2 }}
                                            >
                                                <MenuItem value="" disabled sx={{ display: 'none' }}>BOM 선택</MenuItem>
                                                {bomOptions.map((bom) => (
                                                    <MenuItem key={bom.bom_id} value={bom.bom_id} sx={{ fontSize: '22px', py: 1 }}>
                                                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, width: '100%' }}>
                                                            <img
                                                                src={getImgSrc(bom.item_img_sever)}
                                                                onError={(e) => { e.currentTarget.src = noImg; }}
                                                                alt=""
                                                                style={{ width: '50px', height: '50px', objectFit: 'cover', borderRadius: '6px', border: '1px solid #ccc', backgroundColor: '#fff', flexShrink: 0 }}
                                                            />
                                                            <Box sx={{ display: 'flex', flexDirection: 'column', overflow: 'hidden' }}>
                                                                <Typography sx={{ fontSize: '21px', fontWeight: 'bold', color: '#222', lineHeight: 1.2 }}>{bom.bom_name}</Typography>
                                                                <Typography sx={{ fontSize: '14px', color: '#666' }}>{bom.item_name} {bom.item_spec ? `(${bom.item_spec})` : ''}</Typography>
                                                            </Box>
                                                        </Box>
                                                    </MenuItem>
                                                ))}
                                            </MuiSelect>
                                        </FormControl>

                                        {/* 1장당 생산량 / 재고 표시 */}
                                        <Box sx={{ mt: 0.8, height: '24px', display: 'flex', justifyContent: 'space-between', px: 0.5, alignItems: 'center' }}>
                                            {selectedBom ? (
                                                <>
                                                    <Typography sx={{ color: '#000', fontWeight: 'bold', fontSize: '19px' }}>
                                                        1장당 생산: {Number(selectedBom.bom_item_count).toLocaleString()}개
                                                    </Typography>
                                                    <Typography sx={{ color: '#000', fontWeight: 'bold', fontSize: '19px' }}>
                                                        시트재고: {Number(selectedBom.input_stock).toLocaleString()}
                                                    </Typography>
                                                    <Typography sx={{ color: '#000', fontWeight: 'bold', fontSize: '19px' }}>
                                                        반제품재고: {Number(selectedBom.product_stock).toLocaleString()}
                                                    </Typography>
                                                </>
                                            ) : null}
                                        </Box>
                                    </Box>

                                    {/* ★ 우측 옆 96x96 큼직한 이미지 박스 (클릭 시 모달 확대) */}
                                    <div
                                        onClick={(e) => openImageModal(e, selectedBom?.bom_name, selectedBom?.item_img_sever)}
                                        style={{
                                            width: '96px', height: '96px', borderRadius: '10px',
                                            border: selectedBom ? '2px solid #3D63AE' : '1px solid #c4c4c4',
                                            backgroundColor: '#fff', display: 'flex', alignItems: 'center', justifyContent: 'center',
                                            overflow: 'hidden', flexShrink: 0, position: 'relative',
                                            cursor: 'pointer', boxShadow: '0 2px 6px rgba(0,0,0,0.12)'
                                        }}
                                    >
                                        <img
                                            src={getImgSrc(selectedBom?.item_img_sever)}
                                            onError={(e) => { e.currentTarget.src = noImg; }}
                                            alt="품목이미지"
                                            style={{ width: '100%', height: '100%', objectFit: 'cover', pointerEvents: 'none' }}
                                        />
                                        <div style={{ position: 'absolute', bottom: 0, width: '100%', backgroundColor: 'rgba(0,0,0,0.6)', color: '#fff', fontSize: '12px', fontWeight: 'bold', textAlign: 'center', padding: '2px 0', pointerEvents: 'none' }}>
                                            🔍 확대
                                        </div>
                                    </div>
                                </Box>
                            </Box>

                            {/* 2. 사용 시트 수량 입력 */}
                            <Box>
                                <Typography sx={{ fontSize: '20px', fontWeight: 'bold', color: '#0056b3', mb: 0.8 }}>사용 시트 수량 (장)</Typography>
                                <Box sx={{ display: 'flex', gap: '12px', alignItems: 'stretch', height: '86px' }}>
                                    <TextField
                                        sx={{ flex: 1 }}
                                        type="number"
                                        value={inputs.sheet_count}
                                        disabled={!inputs.selected_bom_id}
                                        inputRef={sheetCountRef}
                                        onChange={onChangeSheet}
                                        InputProps={{ style: { fontSize: '46px', textAlign: 'center', height: '86px', fontWeight: 'bold', color: '#0056b3', backgroundColor: inputs.selected_bom_id ? '#fff' : '#f0f0f0', borderRadius: 8 } }}
                                        placeholder="0"
                                    />
                                    <Box sx={{ display: 'flex', flexDirection: 'column', gap: '6px', width: '84px' }}>
                                        <Button variant="outlined" disableElevation disabled={!inputs.selected_bom_id} onClick={() => sheetStep(1)}
                                            sx={{ flex: 1, minWidth: 0, borderRadius: 1.5, backgroundColor: '#fff', color: '#000', borderColor: '#000', borderWidth: 2, fontSize: 24, fontWeight: 'bold', p: 0, ":hover": { backgroundColor: '#f2f2f2', borderColor: '#000', borderWidth: 2 } }}>▲</Button>
                                        <Button variant="outlined" disableElevation disabled={!inputs.selected_bom_id} onClick={() => sheetStep(-1)}
                                            sx={{ flex: 1, minWidth: 0, borderRadius: 1.5, backgroundColor: '#fff', color: '#000', borderColor: '#000', borderWidth: 2, fontSize: 24, fontWeight: 'bold', p: 0, ":hover": { backgroundColor: '#f2f2f2', borderColor: '#000', borderWidth: 2 } }}>▼</Button>
                                    </Box>
                                </Box>
                            </Box>

                            {/* 3. 계산 결과 : 생산 / 양품 / 불량 (Flex 3단) */}
                            <Box sx={{ display: 'flex', gap: '14px', width: '100%' }}>
                                <Box sx={{ flex: 1, backgroundColor: '#eef4ff', borderRadius: 2, p: 1, textAlign: 'center', border: '1px solid #cdddff', height: '92px', boxSizing: 'border-box', display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>
                                    <Typography sx={{ fontSize: '17px', color: '#28a745', fontWeight: 'bold' }}>생산 수량 (개)</Typography>
                                    <Typography sx={{ fontSize: '36px', fontWeight: 'bold', color: '#28a745', lineHeight: 1.15 }}>{produceQty.toLocaleString()}</Typography>
                                </Box>
                                <Box sx={{ flex: 1, backgroundColor: '#fff', borderRadius: 2, p: 1, textAlign: 'center', border: '1px solid #e0e0e0', height: '92px', boxSizing: 'border-box', display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>
                                    <Typography sx={{ fontSize: '17px', color: '#555', fontWeight: 'bold' }}>양품 수량</Typography>
                                    <Typography sx={{ fontSize: '36px', fontWeight: 'bold', color: '#222', lineHeight: 1.15 }}>{produceQty.toLocaleString()}</Typography>
                                </Box>
                                <Box sx={{ flex: 1, backgroundColor: '#fff', borderRadius: 2, p: 1, textAlign: 'center', border: '1px solid #e0e0e0', height: '92px', boxSizing: 'border-box', display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>
                                    <Typography sx={{ fontSize: '17px', color: '#555', fontWeight: 'bold' }}>불량 수량</Typography>
                                    <Typography sx={{ fontSize: '36px', fontWeight: 'bold', color: '#222', lineHeight: 1.15 }}>0</Typography>
                                </Box>
                            </Box>

                            {/* 4. 하단 실적 등록 버튼 */}
                            {MenuUpdateYN === 'Y' && (
                                <Button
                                    fullWidth
                                    variant="contained"
                                    color="primary"
                                    sx={{ height: '68px', borderRadius: 2.5, flexShrink: 0 }}
                                    onClick={handleSave}
                                >
                                    <span style={{ fontSize: '32px', fontWeight: 'bold' }}>실적 등록</span>
                                </Button>
                            )}
                        </Box>
                    ) : selectedRecord ? (
                        /* ===== 등록된 프레스 실적 상세 ===== */
                        (() => {
                            const st = selectedRecord.start_datetime;
                            const et = selectedRecord.end_datetime;
                            const workTime = (st && et && st !== et) ? (st + ' ~ ' + et) : (st || et || '');
                            const recBom = bomOptions.find(b => String(b.bom_id) === String(selectedRecord.bom_id));
                            const imgFile = selectedRecord.item_img_sever || recBom?.item_img_sever;
                            return (
                        <Box sx={{ width: '100%', maxWidth: '1000px', height: '100%', display: 'flex', flexDirection: 'column', justifyContent: 'space-between', minHeight: 0 }}>
                            {/* 번호 + 상태 */}
                            <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
                                <Typography sx={{ fontSize: '30px', fontWeight: 'bold', color: '#3D63AE', lineHeight: 1.1 }}>{selectedRecord.job_number}</Typography>
                                {selectedRecord.status_name ? (
                                    <Box sx={{ backgroundColor: '#e8f5e9', color: '#2e7d32', fontSize: '15px', fontWeight: 'bold', px: 1.5, py: 0.4, borderRadius: 1.5 }}>{selectedRecord.status_name}</Box>
                                ) : null}
                            </Box>

                            {/* 품목 (이미지 클릭 시 확대 포함) + 작업자/작업시간 */}
                            <Box sx={{ display: 'flex', gap: '14px', width: '100%', height: '88px' }}>
                                <Box sx={{ flex: 7, backgroundColor: '#fff', borderRadius: 2.5, px: 2, boxSizing: 'border-box', boxShadow: '0 1px 4px rgba(0,0,0,0.08)', display: 'flex', alignItems: 'center', gap: 2, overflow: 'hidden' }}>
                                    <img
                                        src={getImgSrc(imgFile)}
                                        onError={(e) => { e.currentTarget.src = noImg; }}
                                        onClick={(e) => openImageModal(e, selectedRecord.bom_name || selectedRecord.item_name, imgFile)}
                                        alt=""
                                        style={{ width: '68px', height: '68px', objectFit: 'cover', borderRadius: '8px', border: '2px solid #3D63AE', flexShrink: 0, cursor: 'pointer' }}
                                    />
                                    <Box sx={{ overflow: 'hidden' }}>
                                        <Typography sx={{ fontSize: '14px', color: '#888' }}>품목 (사진 클릭 시 확대)</Typography>
                                        <Typography sx={{ fontSize: '23px', fontWeight: 'bold', color: '#222', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{selectedRecord.item_name}</Typography>
                                        {selectedRecord.item_spec ? (<Typography sx={{ fontSize: '15px', color: '#999' }}>{selectedRecord.item_spec}</Typography>) : null}
                                    </Box>
                                </Box>
                                <Box sx={{ flex: 5, backgroundColor: '#fff', borderRadius: 2.5, px: 2, boxSizing: 'border-box', boxShadow: '0 1px 4px rgba(0,0,0,0.08)', display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 1 }}>
                                    <Box sx={{ flex: '0 0 36%' }}>
                                        <Typography sx={{ fontSize: '14px', color: '#888' }}>작업자</Typography>
                                        <Typography sx={{ fontSize: '20px', fontWeight: 'bold', color: '#222' }}>{selectedRecord.reg_user_name}</Typography>
                                    </Box>
                                    <Box sx={{ flex: 1, overflow: 'hidden' }}>
                                        <Typography sx={{ fontSize: '14px', color: '#888' }}>작업시간</Typography>
                                        <Typography sx={{ fontSize: '18px', fontWeight: 'bold', color: '#222', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>{workTime}</Typography>
                                    </Box>
                                </Box>
                            </Box>

                            {/* 사용 시트 (BOM) + 사용 시트 수량 (장) */}
                            <Box sx={{ display: 'flex', gap: '14px', width: '100%', height: '72px' }}>
                                <Box sx={{ flex: 7, backgroundColor: '#fff', borderRadius: 2.5, px: 2, display: 'flex', flexDirection: 'column', justifyContent: 'center', boxShadow: '0 1px 4px rgba(0,0,0,0.08)' }}>
                                    <Typography sx={{ fontSize: '15px', color: '#888' }}>사용 시트 (BOM)</Typography>
                                    <Typography sx={{ fontSize: '21px', fontWeight: 'bold', color: '#222' }}>{selectedRecord.bom_name}</Typography>
                                </Box>
                                <Box sx={{ flex: 5, backgroundColor: '#fff', borderRadius: 2.5, px: 2, display: 'flex', flexDirection: 'column', justifyContent: 'center', boxShadow: '0 1px 4px rgba(0,0,0,0.08)' }}>
                                    <Typography sx={{ fontSize: '15px', color: '#888' }}>사용 시트 수량 (장)</Typography>
                                    <Typography sx={{ fontSize: '26px', fontWeight: 'bold', color: '#0056b3' }}>{Number(selectedRecord.sheet_count).toLocaleString()}</Typography>
                                </Box>
                            </Box>

                            {/* 생산 / 양품 / 불량 */}
                            <Box sx={{ display: 'flex', gap: '14px', width: '100%', height: '86px' }}>
                                <Box sx={{ flex: 1, backgroundColor: '#fff', borderRadius: 2.5, display: 'flex', flexDirection: 'column', justifyContent: 'center', textAlign: 'center', boxShadow: '0 1px 4px rgba(0,0,0,0.08)' }}>
                                    <Typography sx={{ fontSize: '15px', color: '#888' }}>생산 수량 (개)</Typography>
                                    <Typography sx={{ fontSize: '30px', fontWeight: 'bold', color: '#28a745' }}>{Number(selectedRecord.produce_count).toLocaleString()}</Typography>
                                </Box>
                                <Box sx={{ flex: 1, backgroundColor: '#fff', borderRadius: 2.5, display: 'flex', flexDirection: 'column', justifyContent: 'center', textAlign: 'center', boxShadow: '0 1px 4px rgba(0,0,0,0.08)' }}>
                                    <Typography sx={{ fontSize: '15px', color: '#888' }}>양품 수량</Typography>
                                    <Typography sx={{ fontSize: '30px', fontWeight: 'bold', color: '#222' }}>{Number(selectedRecord.complete_count).toLocaleString()}</Typography>
                                </Box>
                                <Box sx={{ flex: 1, backgroundColor: '#fff', borderRadius: 2.5, display: 'flex', flexDirection: 'column', justifyContent: 'center', textAlign: 'center', boxShadow: '0 1px 4px rgba(0,0,0,0.08)' }}>
                                    <Typography sx={{ fontSize: '15px', color: '#888' }}>불량 수량</Typography>
                                    <Typography sx={{ fontSize: '30px', fontWeight: 'bold', color: selectedRecord.error_count > 0 ? '#d33' : '#222' }}>{Number(selectedRecord.error_count).toLocaleString()}</Typography>
                                </Box>
                            </Box>

                            {/* 삭제 버튼 */}
                            <Button
                                fullWidth
                                variant="contained"
                                disabled={selectedRecord.use_yn === 'Y'}
                                sx={{ height: '64px', borderRadius: 2.5, flexShrink: 0, backgroundColor: '#d33', ":hover": { backgroundColor: '#b71c1c' }, "&.Mui-disabled": { backgroundColor: '#ccc', color: '#fff' } }}
                                onClick={() => DeleteClick({ row: selectedRecord })}
                            >
                                <span style={{ fontSize: '26px', fontWeight: 'bold' }}>
                                    {selectedRecord.use_yn === 'Y' ? '삭제 불가 (사용/출하됨)' : '삭제'}
                                </span>
                            </Button>
                        </Box>
                            );
                        })()
                    ) : (
                        <div style={{ display: 'flex', height: '100%', justifyContent: 'center', alignItems: 'center', fontSize: '22px', color: '#999', fontWeight: 'bold' }}>
                            👈 좌측에서 작업을 선택하거나, 우측 상단 [등록]을 눌러주세요.
                        </div>
                    )}
                </div>
            </div>

            {/* ★ 직접 구현한 전체화면 이미지 확대 모달 (제목: BOM명) */}
            {imgModal.open && (
                <div
                    onClick={() => setImgModal({ open: false, title: '', src: '' })}
                    style={{
                        position: 'fixed', top: 0, left: 0, right: 0, bottom: 0,
                        backgroundColor: 'rgba(0, 0, 0, 0.72)', zIndex: 99999,
                        display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '20px'
                    }}
                >
                    <div
                        onClick={(e) => e.stopPropagation()}
                        style={{
                            backgroundColor: '#fff', borderRadius: '14px', width: '100%', maxWidth: '660px',
                            overflow: 'hidden', boxShadow: '0 20px 40px rgba(0,0,0,0.4)',
                            display: 'flex', flexDirection: 'column'
                        }}
                    >
                        {/* 모달 헤더 (BOM명) */}
                        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '16px 24px', borderBottom: '1px solid #e0e0e0', backgroundColor: '#3D63AE', color: '#fff' }}>
                            <span style={{ fontSize: '24px', fontWeight: 'bold', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                                {imgModal.title}
                            </span>
                            <button
                                onClick={() => setImgModal({ open: false, title: '', src: '' })}
                                style={{ background: 'transparent', border: 'none', color: '#fff', fontSize: '28px', fontWeight: 'bold', cursor: 'pointer', lineHeight: 1 }}
                            >
                                ✕
                            </button>
                        </div>

                        {/* 모달 바디 (확대 이미지) */}
                        <div style={{ padding: '24px', backgroundColor: '#f8f9fa', display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '420px' }}>
                            <img
                                src={imgModal.src || noImg}
                                onError={(e) => { e.currentTarget.src = noImg; }}
                                alt={imgModal.title}
                                style={{ width: '100%', maxWidth: '580px', maxHeight: '60vh', objectFit: 'contain', borderRadius: '8px', backgroundColor: '#fff', border: '1px solid #ddd' }}
                            />
                        </div>

                        {/* 모달 하단 닫기 버튼 */}
                        <div style={{ padding: '12px 24px', borderTop: '1px solid #e0e0e0', display: 'flex', justifyContent: 'flex-end', backgroundColor: '#fff' }}>
                            <Button
                                variant="contained"
                                onClick={() => setImgModal({ open: false, title: '', src: '' })}
                                sx={{ fontSize: '20px', fontWeight: 'bold', px: 4, py: 1, backgroundColor: '#3D63AE' }}
                            >
                                닫기
                            </Button>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
};

export default TAB_ENC_PressProcess;